import React from 'react';
import PropTypes from 'prop-types';

const Bass = ({ theme, fill, ...props }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0)">
      <path
        d="M8.38412 0.164917C8.38428 0.482374 8.32188 0.796752 8.20047 1.09008C8.07906 1.3834 7.90103 1.64992 7.67655 1.8744C7.45207 2.09887 7.18556 2.2769 6.89223 2.39831C6.59891 2.51972 6.28453 2.58213 5.96707 2.58196H2.42459V1.63025C2.46362 0.721341 2.67007 0.164917 3.45687 0.164917H8.38412Z"
        fill={fill || theme.GLOBAL_SIDEBAR.primaryBtn}
      />
      <path
        d="M2.41704 17.083V2.58196H2.4246V1.63025C2.46362 0.721341 2.67008 0.164917 3.45688 0.164917H2.41704C1.776 0.164917 1.16122 0.419569 0.707936 0.872853C0.254652 1.32614 0 1.94092 0 2.58196V19.5H16.2244C16.9193 19.5 16.8539 18.5836 16.9193 17.083H2.41704Z"
        fill={fill || theme.GLOBAL_SIDEBAR.primaryBtn}
      />
      <path
        d="M2.41705 2.03916C2.41705 1.89694 2.41705 1.75976 2.42439 1.63013V2.5816C2.42072 2.39282 2.41705 2.21158 2.41705 2.03916Z"
        fill={fill || theme.GLOBAL_SIDEBAR.primaryBtn}
      />
      <path
        d="M19.3363 12.2501V17.083C19.3365 17.4004 19.2741 17.7148 19.1527 18.0081C19.0313 18.3014 18.8533 18.568 18.6288 18.7924C18.4043 19.0169 18.1378 19.1949 17.8445 19.3163C17.5511 19.4378 17.2368 19.5002 16.9193 19.5H16.2244C16.9193 19.5 16.8538 18.5835 16.9193 17.083V14.6672C16.9193 14.0261 17.1739 13.4113 17.6272 12.9581C18.0805 12.5048 18.6953 12.2501 19.3363 12.2501Z"
        fill={fill || theme.GLOBAL_SIDEBAR.primaryBtn}
      />
      <path
        d="M14.9781 0.692293C14.7563 0.469288 14.4924 0.292492 14.2017 0.172133C13.9111 0.0517742 13.5995 -0.00975754 13.2849 -0.00890234C13.0443 -0.00887327 12.8051 0.0267614 12.5749 0.0968434C12.2028 0.21133 11.8647 0.415856 11.5905 0.692293L7.27631 4.99891H7.25113V12.2501H11.4545C12.0965 12.2501 12.0575 11.3386 12.0965 9.85818H9.64677V6.02112L13.2824 2.38548C14.3613 1.36202 14.9769 0.692293 15.4301 1.14675L14.9781 0.692293Z"
        fill={fill || theme.GLOBAL_SIDEBAR.primaryBtn}
      />
      <path
        d="M14.4922 9.85313V4.9989C13.8578 4.9989 13.2494 5.2509 12.8009 5.69946C12.3523 6.14803 12.1003 6.75641 12.1003 7.39077V9.87076C12.0613 11.3462 12.1003 12.2513 11.4583 12.2513H12.1104C12.7448 12.2513 13.3531 11.9993 13.8017 11.5507C14.2503 11.1022 14.5023 10.4938 14.5023 9.85943H14.4922V9.85313Z"
        fill={fill || theme.GLOBAL_SIDEBAR.primaryBtn}
      />
      <path
        d="M19.2847 4.99892L15.4313 1.14675C14.9781 0.692296 14.3625 1.36202 13.2837 2.38549L16.9193 6.02112V8.94676C16.9193 9.58112 17.1713 10.1895 17.6199 10.6381C18.0684 11.0866 18.6768 11.3386 19.3112 11.3386V4.99892H19.2847Z"
        fill={fill || theme.GLOBAL_SIDEBAR.primaryBtn}
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

Bass.propTypes = {
  fill: PropTypes.string,
  theme: PropTypes.object,
};

export default Bass;
